module.exports = __webpack_public_path__ + "static/media/37pic.5606508c.jpg";